import React, { useState } from "react";
import { HiX } from "react-icons/hi";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import SidebarLinks from "./components/Links";
import routes from "routes.js";

const Sidebar = ({ open, onClose, onCollapse }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    onCollapse(newCollapsedState);
  };

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        isCollapsed ? "w-[80px]" : "w-[300px]"
      } ${open ? "translate-x-0" : "-translate-x-96"}`}
    >
      {/* Mobile Close Button */}
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      {/* Sidebar Header */}
      <div className={`mx-4 mt-4 flex items-center ${isCollapsed ? "justify-center" : "justify-start"}`}>
        <div
          className={`mt-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white ${
            isCollapsed ? "text-sm" : "text-lg"
          }`}
        >
          {isCollapsed ? "QB" : "QUALBOTS"}
          {!isCollapsed && <span className="font-medium">CE</span>}
        </div>
      </div>
      <div className="mt-4 mb-7 h-px bg-gray-300 dark:bg-white/30" />

      {/* Sidebar Menu */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden scrollbar-thin">
        <SidebarLinks routes={routes} isCollapsed={isCollapsed} />
      </div>

      {/* Collapse/Expand Button */}
      <button
        onClick={toggleSidebar}
        className="absolute top-1/2 -right-3 transform -translate-y-1/2 bg-indigo-600 text-white p-2 rounded-full shadow-md hover:bg-indigo-700 transition-colors"
        aria-label={isCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
      >
        {isCollapsed ? <MdChevronRight className="h-5 w-5" /> : <MdChevronLeft className="h-5 w-5" />}
      </button>
    </div>
  );
};

export default Sidebar;